import React from "react";
import {RotatingLines} from "react-loader-spinner";
import {useIsAuthenticated} from "@azure/msal-react";

function PrivateRoute({children}) {
    const isAuthenticated = useIsAuthenticated();

    if (!isAuthenticated) {
        return (
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
                <RotatingLines color="#3498db" height={280} width={280} />
            </div>
        );
    }

    return isAuthenticated ? children : null;

}

export {PrivateRoute}